<template>
  <div class="login">
    <el-header class="lg-header">
      <logo/>
      <div class="lg-language">
        <el-dropdown>
                    <span class="el-dropdown-link">
                      {{$t('language')}}
                    </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="toggleLang('zh')" :disabled="$i18n.locale == 'zh'">中文</el-dropdown-item>
            <el-dropdown-item @click.native="toggleLang('en')" :disabled="$i18n.locale == 'en'">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-main class="lg-main">
      <el-row class="lg-row">
        <el-col :span="16">
          <p class="lg-info">{{$t('TB_tip')}}</p>
          <img src="../assets/img/panit.png"/>
        </el-col>
        <el-col :span="8">
          <div class="lg-info-container">
            <div class="lg-info-border">
              <div class="lg-info-form" v-show="!checkEnterprise">
                <p class="form-title">{{$t('login_entry')}}</p>
                <el-input :placeholder="$t('qing_shu_ru_shou_ji_hao_ma')" class="form-input" v-model="account.phone"></el-input>
                <el-input :placeholder="$t('qing_shu_ru_deng_lu_mi_ma')" class="form-input"
                          type="password"
                          v-model="account.password"></el-input>
                <el-row>
                  <el-col :span="14" >
                    <el-input :placeholder="$t('qing_shu_ru_yan_zheng_ma')" v-model="account.captcha" class="form-input"></el-input>
                  </el-col>
                  <el-col :span="10"  class="form-forget">
                    <img :src="captcha" style="max-width: 80%;height: 40px" @click="loadCaptcha"/>
                  </el-col>
                </el-row>
                <p class="form-submit" @click="handleLogin">{{$t('deng_lu', ['login'])}}</p>
                <el-row>
                  <el-col :span="16" class="form-company">{{$t('huan_ying_shi_yong')}}</el-col>
                  <el-col :span="8" :gutter="8" class="form-forget" @click.native="handleForgetPassword">{{$t('wang_ji_mi_ma')}}</el-col>
                </el-row>
              </div>

              <transition name="fade-transform">
                <div class="dialog dialog-forget-pwd" v-show="checkEnterprise" @click.stop.prevent>
                  <div class="user-login">
                    <h2>{{$t('xuan_qu_gong_si')}}</h2>
                    <ul class="list-enterprise">
                      <li v-for="(enterprise, index) in enterprises"
                          @click="login(enterprise.uuid)"
                          :key="index">
                        {{enterprise.name}}
                      </li>
                    </ul>
                  </div>
                </div>
              </transition>
            </div>


          </div>

        </el-col>
      </el-row>
    </el-main>
  </div>
</template>

<script>
  import Logo from '@/components/Logo'
  import {checkPhone} from '@/util/checkLogin'
  import {mapActions} from 'vuex'
  import {employeeLogin, employeeAccount, employeeModules, employeeCaptcha} from '@/api/account/employee'
  import {setToken, removeToken} from '@/util/auth'
  import {hex_md5} from '@/util/md5'
  // import BMF from 'browser-md5-file';
  export default {
    name: '',
    components: {
      Logo
    },
    mounted: function () {
      this.loadCaptcha()
    },
    data: function () {
      return {
        account: {
          phone: '',
          password: '',
          id: '',
          captcha: '',
        },
        captcha:'',
        checkEnterprise: false,
        enterprises: []
      }
    },
    methods: {
      ...mapActions(["setEnterpriseMenu"]),
      ...mapActions(["setEnterpriseEmployee"]),
      handleLogin() {
        let res = checkPhone(this.account.phone)
        if (!res.status) {
          this.$message.error(res.msg)
          return
        }

        if (!this.account.captcha) {
          this.$message.error(this.$t('qing_shu_ru_yan_zheng_ma'))
          return
        }

        if (!this.account.password) {
          this.$message.error(this.$t('complete_info'))
          return
        }
        employeeAccount(this.account.phone).then(res => {
          if (res.code == 0) {
            if (res.data) {
              if (res.data.length > 1) {
                this.enterprises = res.data;
                this.checkEnterprise = true
              } else {
                this.login(res.data[0].uuid)
              }
            } else {
              this.$message.error(this.$t('unbind_enterprise'))
            }
          }
        });
      },
      toggleLang(lang) {
        if (lang == 'zh') {
          localStorage.setItem('locale', 'zh')
          this.$i18n.locale = localStorage.getItem('locale')
        } else if (lang == 'en') {
          localStorage.setItem('locale', 'en')
          this.$i18n.locale = localStorage.getItem('locale')
        }
      },
      handleForgetPassword() {
        this.$message.warning(this.$t('forget_password_tip'))
      },
      loadModule() {
      },
      login(uuid) {
        let vue = this
        let password = hex_md5(this.account.password);
        employeeLogin({...this.account, password:password}, uuid).then(res => {
          if (res.code == 0) {
            setToken(res.refreshToken);
            this.setEnterpriseEmployee(res.data);
            employeeModules().then(res => {
              if (res.code == 0) {
                vue.$store.dispatch('setEnterpriseMenu', res.data)
                vue.$router.replace({name: res.data[0].modules[0].webRouterName})
              }
            })
          } else {
            this.$message.error(res.msg)
            this.loadCaptcha()
          }
        }).catch(() => {
          this.loadCaptcha()
          removeToken()
        })
      },
      loadCaptcha() {
        employeeCaptcha().then(res => {
          let data = res.data
          this.account.id = data.id
          this.captcha = data.img
        })
      }
    },
  }
</script>

<style lang="scss">
  .login {
    height: 100%;
    width: 100%;
    background-color: $bg_color;
    display: flex;
    flex-direction: column;

    .lg-header {
      background-color: $bg_sec_color;
      height: $_header_height !important;
    }

    .lg-language{
      float: right;
      margin-top: 20px;
    }
    .lg-language:after{
      content: ' ';
      display: inline-block;
      clear: both;
    }

    .el-dropdown-link {
      cursor: pointer;
      color: $f_color;
      border: 1px solid $f_color;
      padding: 1px 2px;
    }


    .lg-main {
      flex: 1;

      .lg-row {
        height: 100%;

        .el-col {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          .lg-info {
            font-size: 1.5rem;
            font-weight: 600;
            color: $f_sec_color;
          }

          img {
            display: block;
            max-width: 60%;
          }
        }
      }

      .lg-info-container {
        width: 80%;
        max-width: 24rem;
        height: 24rem;
        background: transparent;
        box-shadow: 0.1rem 0.1rem 1rem #191f2b;
        background: $lg_border_color;
        clip-path: polygon(14% 0, 100% 0, 100% 93%, 91% 100%, 0 100%, 0 13%);

        .lg-info-border {
          clip-path: polygon(14% .3%, 99.7% .3%, 99.7% 92.9%, 90.9% 99.7%, .3% 99.7%, .3% 13.3%);
          background-color: $bg_color;
          height: 100%;
          width: 100%;
          padding: 2rem;

          .lg-info-form {
            width: 100%;
            height: 100%;

            .form-title {
              color: $f_sec_color;
              font-size: 1.2rem;
              font-weight: 500;
              text-align: center;
              padding: 1.2rem 0;
            }

            .form-input {
              .el-input__inner {
                background-color: $bg_th_color;
                margin-bottom: 1rem;
              }
            }

            .form-submit {
              cursor: pointer;
              width: 100%;
              text-align: center;
              margin-top: 2rem;
              margin-bottom: .5rem;
              border-radius: 4px;
              border: 1px solid $border_color;
              padding: 12px;
            }

            .form-submit:hover {
              background-color: $f_color;
              color: #ffffff;

            }

            .form-company {
              align-items: flex-start;
              font-size: .8rem;
            }

            .form-forget {
              align-items: flex-end;
              font-size: .8rem;
              cursor: pointer;
            }
          }
        }

      }
    }

    .dialog {
      text-align: center;

      .list-enterprise {
        li {
          cursor: pointer;
          line-height: 30px;
          padding: 5px 0;
        }

        li:hover {
          cursor: pointer;
          font-size: 16px;
          font-weight: 600;
          color: $f_color;
        }
      }
    }
  }
</style>
